export const DEFAULT_MOBILE_SQL = '';

export const DEFAULT_PAGE_SIZE = 50;
